/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type AdvancedRoadmapsPlanType from '@jira/spa-apps__advanced-roadmaps-plan/src/AdvancedRoadmapsPlanType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Plan Page
 */

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyAdvancedRoadmapsPlanExport: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof AdvancedRoadmapsPlanType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-advanced-roadmaps-plan", jiraSpaEntry: "async-advanced-roadmaps-plan" */ '@jira/spa-apps__advanced-roadmaps-plan/src/AdvancedRoadmapsPlanType.tsx'
			),
		),
	{ ssr: false },
);

const AsyncAdvancedRoadmapsPlanExport = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAdvancedRoadmapsPlanExport}
		pageId="advanced-roadmaps-plan"
		shouldShowSpinner
	/>
);

export default AsyncAdvancedRoadmapsPlanExport;
